import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=676225cc&scoped=true&"
import script from "./UnitList.vue?vue&type=script&lang=js&"
export * from "./UnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676225cc",
  null
  
)

export default component.exports